const countries = [
  {
    value: 'USA',
    shortLabel: 'US',
    fullLabel: 'United States',
    flag: 'https://m.bbb.org/terminuscontent/dist/img/header/flag-us-100__100w.png',
    culture: 'en-us',
  },
  {
    value: 'CAN',
    shortLabel: 'CA',
    fullLabel: 'Canada',
    flag: 'https://m.bbb.org/terminuscontent/dist/img/header/flag-ca-100__100w.png',
    culture: 'en-ca',
  },
];

export default countries;
